module.exports = __webpack_public_path__ + "static/media/pos_blog_2.1926163b.png";